import { ChevronDownIcon } from "lucide-react";
import { Popover as PopoverPrimitive } from "radix-ui";
import type * as React from "react";

import { cn } from "#/lib/utils";

function Popover(props: React.ComponentProps<typeof PopoverPrimitive.Root>) {
	return <PopoverPrimitive.Root data-slot="popover" {...props} />;
}

function PopoverTrigger({
	className,
	...props
}: React.ComponentProps<typeof PopoverPrimitive.Trigger>) {
	return (
		<PopoverPrimitive.Trigger
			data-slot="popover-trigger"
			className={cn("group/popover-trigger", className)}
			{...props}
		/>
	);
}

function PopoverPortal(
	props: React.ComponentProps<typeof PopoverPrimitive.Portal>,
) {
	return <PopoverPrimitive.Portal data-slot="popover-portal" {...props} />;
}

function PopoverContent({
	className,
	align = "center",
	sideOffset = 8,
	collisionPadding = 16,
	...props
}: React.ComponentProps<typeof PopoverPrimitive.Content>) {
	return (
		<PopoverPortal>
			<PopoverPrimitive.Content
				data-slot="popover-content"
				align={align}
				sideOffset={sideOffset}
				collisionPadding={collisionPadding}
				className={cn(
					"z-50 origin-[var(--radix-popover-content-transform-origin)] rounded-2xl border border-trade-border bg-popover shadow-2xl outline-none data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
					className,
				)}
				{...props}
			/>
		</PopoverPortal>
	);
}

type PopoverChevronIconProps = React.ComponentProps<typeof ChevronDownIcon> & {
	open?: boolean;
};

function PopoverChevronIcon({
	className,
	open = false,
	...props
}: PopoverChevronIconProps) {
	return (
		<ChevronDownIcon
			data-slot="popover-trigger-icon"
			className={cn(
				"pointer-events-none shrink-0 will-change-transform transition-transform duration-200 ease-out motion-reduce:transition-none group-data-[state=open]/popover-trigger:rotate-180",
				open && "rotate-180",
				className,
			)}
			{...props}
		/>
	);
}

export {
	Popover,
	PopoverChevronIcon,
	PopoverContent,
	PopoverTrigger,
};
